// extracted by mini-css-extract-plugin
export default {"circularProgressBar":"ILetrusModal_circularProgressBar__irJ8E","iLetrusScoreBody":"ILetrusModal_iLetrusScoreBody__zv2+Q","wrapper":"ILetrusModal_wrapper__hlR50"};